import {COLORS} from '../utils/style-variables';

export const TABLE = {
  row: {
    borderWidth: 1,
    borderBottomStyle: 'solid',
    borderColor: COLORS.lightGrey30Color,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '10px 16px',
    '@media (max-width: 768px)': {
      padding: '9px 8px'
    }
  }
};

export const banksTableStyles = {
  tableNameColumn: {
    '& span': {
      fontWeight: 'bold'
    },
    minWidth: 'calc(100% - 490px)',
    maxWidth: '230px',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    '@media (max-width: 768px)': {
      minWidth: 'none',
      width: '100%',
      maxWidth: 'calc(100% - 180px)'
    }
  },
  tableSellColumn: {
    width: '120px',
    paddingRight: 18,
    textAlign: 'right',
    '&.sell_asc': {
      '&:before': {
        content: 'none'
      },
      '&:after': {
        bottom: 'calc(50% - 3px)'
      }
    },
    '&.sell_desc': {
      '&:before': {
        top: 'calc(50% - 3px)'
      },
      '&:after': {
        content: 'none'
      }
    },
    '@media (max-width: 768px)': {
      width: 80,
      paddingRight: 0
    }

  },
  tableBuyColumn: {
    width: '120px',
    paddingRight: 18,
    textAlign: 'right',
    '&.buy_asc': {
      '&:before': {
        content: 'none'
      },
      '&:after': {
        bottom: 'calc(50% - 3px)'
      }
    },
    '&.buy_desc': {
      '&:before': {
        top: 'calc(50% - 3px)'
      },
      '&:after': {
        content: 'none'
      }
    },
    '@media (max-width: 768px)': {
      width: 80,
      paddingRight: 0
    }

  },
  tableUpdateColumn: {
    width: '100px',
    textAlign: 'right',
    '@media (max-width: 768px)': {
      display: 'none'
    }
  },
  tableBranchColumn: {
    width: '150px',
    textAlign: 'right',
    userSelect: 'none',
    '@media (max-width: 768px)': {
      width: '20px'
    }
  },
  tableColumn: {
    position: 'relative'
  }
};
